import {isNil} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';

import {buildArray, Nullish} from 'shared/web';

interface RentalOrderActivityPanelProps {
  rentalOrderId: string | Nullish;
}

export function RentalOrderActivityPanel(props: RentalOrderActivityPanelProps) {
  if (isNil(props.rentalOrderId)) {
    return null;
  }

  const actions = buildArray<ActivitySidebarAction>().whenFeatureEnabled(
    featureFlags.CUSTOM_NOTICES,
    buildCustomNoticesSidebarAction({
      resourceId: EntityResourceIds.rentalOrder,
      recordId: props.rentalOrderId,
    })
  );

  return <ActivitySidebarV2 actions={actions} />;
}
